<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-notice-bar 
        v-show="false"
  text="请填写真实可收件地址，以便后期邮寄培训班相关物料。"
/>
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-field
                        v-model="formData.saiji_name"
                        label="赛季"
                        input-align="right"
                        readonly
                />

                <van-field name="radio" label="赛事类型"
                :rules="[{ required: true, message: '请选择赛事类型' }]"
                        input-align="right">
                    <template #input>
                        <van-radio-group @change="typeChange" v-model="formData.type_name" direction="vertical">
                            <van-radio :key="0" checked-color="#ffb01b" name="全国啦啦操联赛">全国啦啦操联赛</van-radio>
                            <van-radio :key="1" checked-color="#ffb01b" name="全国少儿啦啦操精英赛">全国少儿啦啦操精英赛</van-radio>
                            <van-radio :key="2" checked-color="#ffb01b" name="全国啦啦操俱乐部联赛">全国啦啦操俱乐部联赛</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                        v-model="formData.date_time"
                        label="赛事时间"
                        input-align="right"
                        @click="dateShow=true"
                        readonly
                />
                <div class="operate-desc-left"  >至少2晚3天，允许3晚4天。</div>

                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.county?(formData.province+'/'+formData.city+'/'+formData.county):''"
                        input-align="right"
                        label="赛事地点"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>

                <van-cell
                    title="赛事站名" :value="saiName"  
                        input-align="right"
                        readonly
                />

 
                <van-popup v-model="showeArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.earea"
                            @confirm="oneAreaConfirm"
                            @cancel="showeArea = false"
                    />
                </van-popup>

                <van-field 
                        v-model="formData.member"
                        :rules="[{ required: true,message:'请输入人数'}]"
                        error-message-align="right"
                        label="预估参赛人数"
                        input-align="right"
                        clearable
                        placeholder="请输入人数"
                />
  

            </van-cell-group>


        <div :key="index" v-for="(member,index) in formData.admin_list">
          <van-divider>赛事负责人{{index+1}}
          </van-divider>
          <van-cell-group>
            <van-field
                v-model="member.name"
                clearable
                input-align="right"
                error-message-align="right"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
            />
            <van-field
                v-model="member.phone"
                clearable
                :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                error-message-align="right"
                input-align="right"
                label="手机"
                placeholder="请输入手机号"
            /> 
            <div style="height: 0.2rem"></div>

          </van-cell-group>

          <div style="text-align: center">
            <van-button
                native-type="button"
                style="width: 3rem;"
                size="normal" round icon="close"   @click="adminRemove(member,index)">删除负责人{{index+1}}</van-button>
          </div>


        </div>

        <div style="text-align: center">
          <van-button
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round  icon="plus"  @click="adminAdd()">新增负责人</van-button>

        </div>


        <div :key="index" v-for="(member,index) in formData.service_list">
          <van-divider>赛事咨询人{{index+1}}
          </van-divider>
          <van-cell-group>
            <van-field
                v-model="member.name"
                clearable
                input-align="right"
                error-message-align="right"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
            />
            <van-field
                v-model="member.phone"
                clearable
                :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                error-message-align="right"
                input-align="right"
                label="手机"
                placeholder="请输入手机号"
            /> 
            <div style="height: 0.2rem"></div>

          </van-cell-group>

          <div style="text-align: center">
            <van-button
                native-type="button"
                style="width: 3rem;"
                size="normal" round icon="close"   @click="serviceRemove(member,index)">删除咨询人{{index+1}}</van-button>
          </div>


        </div>

        <div style="text-align: center">
          <van-button
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round  icon="plus"  @click="serviceAdd()">新增咨询人</van-button>

        </div>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
            </div>
        </van-form>


    <van-calendar v-model="dateShow" type="range" :min-date="minDate" :max-date="maxDate" @confirm="onDateConfirm" />
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../../utils/area";
    import validator from "../../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider,Calendar, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Calendar);
    export default {
        name: 'HuiyiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                dateShow:false,
                loginShow:false,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                numTypeColumns: ['身份证', '护照'],
                showeArea:false,
                showArea:false,
                areaList:{},
                saiName:'-',
                areaValue:'',
                submitType:'',
                minDate: new Date(2010, 0, 1),
                maxDate: new Date(2024, 7, 31),
                clockSecond:0,
                formData: {
                    id:0,
                    areas:'',
                    member:'',
                    admin_list:[
                        {
                            name:'',
                            phone:'',
                        }
                    ],
                    service_list:[
                        {
                            name:'',
                            phone:'',
                        }
                    ],
                    time_range:[],
                    saiqu_name:'',
                    saiji_name:'',
                    danwei:'',
                    ldname:'',
                    weixin:'',
                    address:'',
                    phone:'',
                    email:'',
                    province:'',
                    city:'',
                    county:'',
                    eareas:'',
                    eprovince:'',
                    ecity:'',
                    ecounty:'',
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            document.title = '赛事申报';
            
            this.fetch();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
                this.freshSaiName()
            },
            oneAreaConfirm(values) {
                console.log(values);
                this.formData.earea = values[2].code;
                this.formData.eprovince = values[0].name;
                this.formData.ecity = values[1].name;
                this.formData.ecounty = values[2].name;
                this.showeArea = false;
            },
            adminAdd(){
                this.formData.admin_list.push({
                    name:'',
                    phone:''
                })
            },
            adminRemove(index){
                this.formData.admin_list.splice(index,1);
            },
            serviceAdd(){
                this.formData.service_list.push({
                    name:'',
                    phone:''
                })
            },
            serviceRemove(index){
                this.formData.service_list.splice(index,1);
            },
            fetch(){
                let that = this;
                that.$api.get('/wyhadminapi/sai/saiquapplyh5detail', { 
                    id : that.formData.id,
                }, (res) => { 
                    this.minDate = new Date(res.data.year, res.data.month-1, res.data.day)
                    if(res.data.notice){
                        Dialog.alert({
                        title: '报名须知',
                        message: res.data.notice
                        }).then(() => {
                        // on close 
                        });
                        return ;
                    } 
                    that.formData = Object.assign(that.formData,res.data)
                },(res) =>{

                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            }, 
            onQuestion(){
                console.log('onQuestion')
            },
            jumToOld(id){
                rbLink({
                    name:'HuiyiApplyList'
                },'replace')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                    if (this.formData.time_range.length<2) {
                        Toast('请选择日期');
                        return
                    }
                }
                that.saveLoading = true;
                that.$api.post('/wyhadminapi/sai/addSaiquH5Apply', that.formData, (res) => {
                    that.saveLoading = false;

                    Toast('提交成功');
                    setTimeout(() =>{
                        rbLink({
                            name:'WyhSaiQuApplyList','query':{ }
                        },'replace');
                    },1000)
                        


                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;clockSecond
            },
            typeChange(val){
                if( this.formData.type_name=='全国啦啦操联赛'){
                        Dialog.alert({
                            title: '申报须知',
                            message: '该赛事须落实赛事经费方可申办',
                            confirmButtonText:'我知道了',
                        }).then(() => {
                        // on close 

                            this.freshSaiName();
                        });
                        return ;
                    // 
                }
                this.freshSaiName();
                console.log(val)
            },
            formatDate(date) {
            return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onDateConfirm(date) {
            // const [start, end] = date;
            const start = datdate.start
            const end = datdate.end
            this.formData.time_range = [];
            let s_time = this.timestampToTime(
                parseInt(start.setHours(0, 0, 0) / 1000)
            );
            let e_time = this.timestampToTime(
                parseInt(end.setHours(23, 59, 59) / 1000)
            );
            this.formData.time_range[0] = s_time;
            this.formData.time_range[1] = e_time;
            this.dateShow = false;
            this.formData.date_time = s_time + "-" + e_time;
            },
            timestampToTime(timestamp) {
            var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

            let Y = date.getFullYear() + "-";

            let M =
                (date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1) + "-";

            let D = date.getDate() + " ";

            let h = date.getHours() + ":";

            let m = date.getMinutes() ;

            let s = date.getSeconds();

            return Y + M + D
            },
            freshSaiName(){
                let that = this;
                this.saiName = '-';  

                if(!that.formData.area || !that.formData.type_name){
                    this.saiName = '-';  
                    return ;
                }
                // 

                that.$api.get('/api/utils/getCityName', {
                    area:that.formData.area
                }, (res) => { 
                    console.log(res.data)
                    that.saiName =  that.formData.saiji_name+''+that.formData.type_name+'('+res.data+'站)'  
                })
 
            },
            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SaiquApplyFormStep1.vue?3e8167e8